import React from 'react';
import InputTextField from 'components/common/InputTextField';
import { SANITIZATION_TYPES } from '../../common/sanitizationTypes';

export const SaveFileDialogContainer = ({ currentCode, touched, name, code, comment, onChange, onBlur, titleName }) => {
    return (
        <div>
            <div className="modal-save-mb-10"></div>
            <div className="col-xs">
                <InputTextField
                    sparkInputProps={{
                        label: `${titleName} Name*`,
                        errorMessage: !name && touched.name ? 'Field is required' : ''
                    }}
                    name="name"
                    value={name}
                    onChange={value => onChange('name', value)}
                    onBlur={() => onBlur('name')}
                />
            </div>
            <div className="modal-save-mb-10"></div>
            <div className="col-xs">
                <InputTextField
                    disabled={!!currentCode}
                    sparkInputProps={{
                        label: `${titleName} Code*`,
                        errorMessage: !code && touched.code ? 'Field is required' : ''
                    }}
                    name="code"
                    value={code}
                    onChange={value => onChange('code', value)}
                    onBlur={() => onBlur('code')}
                />
            </div>
            <div className="modal-save-mb-10"></div>
            <div className="col-xs">
                <InputTextField
                    sparkInputProps={{
                        label: `${titleName} Comment*`,
                        errorMessage: !comment && touched.comment ? 'Field is required' : ''
                    }}
                    name="coment"
                    value={comment}
                    onChange={value => onChange('comment', value)}
                    replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                    sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                    onBlur={() => onBlur('comment')}
                />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/modals/editFile/SaveFileDialogContainer.js